import "./SalaryDetails.css";
import { lazy, useCallback, useEffect, useState, useRef } from "react";
import ButtonCom from "../../../components/button/button";
import { Form, Row, Col } from "react-bootstrap";
import { getCapitalizeWord } from "../../../services/commonServices";
import {
  getPayrollModelListPath,
  calculatePayrollPath,
  savePayrollEmployeePath,
} from "../../../services/config";
import { useDispatch, useSelector } from "react-redux";
import {
  commonSaveData,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import {
  initSalaryState,
  saveUpdateSalary,
} from "../../../redux/slices/salarySlice";
import { getPayrollModuleList } from "../../../redux/slices/payrollSlice";
import { ToastContainer, toast } from "react-toastify";
import Switch from "@mui/material/Switch";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const SalaryDetails = ({ staffId, staffName, handleSaveSalary }) => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const dispatch = useDispatch();
  const commonStore = useSelector((state) => state.common);
  const payrollListStore = useSelector((state) => state.payroll);
  const salaryStore = useSelector((state) => state.salary);

  const [state, setState] = useState({
    payrollList: [],
    month: "",
    payrollType: "monthly",
    grossPayAmount: "",
    grossMonthlyOrYearly: "0", // 0 - Monthly 1-Yearly
    data: {},
    dearnessName: "",
    dearnessMonthlyAmount: "",
    dearnessYearlyAmount: "",
  });

  const contentRef = useRef();
  const [errorMessage, setErrorMessage] = useState("");

  const [earningAllowance, setEarningAllowance] = useState([]);
  const [newAllowance, setNewAllowance] = useState([]);
  const [maxMonth, setMaxMonth] = useState("");

  useEffect(() => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    setMaxMonth(`${year}-${month}`);
    setState((prev) => ({
      ...prev,
      payrollList: [],
      month: `${year}-${month}`,
      payrollType: "monthly",
      grossPayAmount: "",
      grossMonthlyOrYearly: "0",
      data: {},
      dearnessName: "",
      dearnessMonthlyAmount: "",
      dearnessYearlyAmount: "",
    }));
  }, []);

  const getPayrollList = useCallback(() => {
    const path = getPayrollModelListPath + user.user_id;
    dispatch(getPayrollModuleList(path));
  }, []);

  useState(() => {
    getPayrollList();
  }, []);

  const handleMonth = (e) => {
    setState((pre) => ({
      ...pre,
      month: e.target.value,
    }));
    setState((pre) => ({
      ...pre,
      data: {},
    }));

    const data = {
      path: calculatePayrollPath,
      data: {
        userId: user.user_id,
        staffId: staffId,
        payrollModelId: state.payrollModelId,
        grossPayAmount: state.grossPayAmount,
        grossMonthlyOrYearly: state.grossMonthlyOrYearly, // 0 - Monthly 1-Yearly
        payrollType: state.payrollType,
        payrollDate: e.target.value,
      },
    };
    dispatch(commonSaveData(data));
  };

  const handleSalaryType = (e) => {
    setState((pre) => ({
      ...pre,
      payrollType: e.target.value,
    }));
    setState((pre) => ({
      ...pre,
      data: {},
    }));
    if (state.grossPayAmount && state.payrollModelId) {
      const data = {
        path: calculatePayrollPath,
        data: {
          userId: user.user_id,
          staffId: staffId,
          payrollModelId: state.payrollModelId,
          grossPayAmount: state.grossPayAmount,
          grossMonthlyOrYearly: state.grossMonthlyOrYearly,
          payrollType: e.target.value,
          payrollDate: `${state.month}-01`,
        },
      };
      dispatch(commonSaveData(data));
      setErrorMessage("");
    } else {
      setErrorMessage(
        `Please select ${!state.payrollModelId ? "Salary Structure" : ""} 
        ${!state.payrollModelId && !state.ctc ? "and" : ""} 
        ${!state.ctc ? " gross amount" : ""} first to proceed`
      );
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
      // toast.error("Please select Salary Structure and CTC first to proceed");
    }
  };

  const handleSalaryStructure = (e) => {
    setState((pre) => ({
      ...pre,
      payrollModelId: e.target.value,
    }));
    setState((pre) => ({
      ...pre,
      data: {},
    }));
    if (state.grossPayAmount && state.payrollType) {
      const data = {
        path: calculatePayrollPath,
        data: {
          userId: user.user_id,
          staffId: staffId,
          payrollModelId: e.target.value,
          grossPayAmount: state.grossPayAmount,
          grossMonthlyOrYearly: state.grossMonthlyOrYearly,
          payrollType: state.payrollType,
          payrollDate: `${state.month}-01`,
        },
      };
      setErrorMessage("");
      dispatch(commonSaveData(data));
    } else {
      setErrorMessage(
        `Please select ${!state.payrollType ? "Salary Type" : ""}  
        ${!state.payrollType && !state.ctc ? "and" : ""} 
         ${!state.ctc ? " CTC" : ""} first to proceed`
      );
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
      // toast.error("Please select Salary Type and CTC first to proceed");
    }
  };

  const handleGrossPayAmount = (e) => {
    setState((pre) => ({
      ...pre,
      grossPayAmount: e.target.value,
    }));
    setState((pre) => ({
      ...pre,
      data: {},
    }));
    if (e.target.value.length > 3) {
      if (state.payrollModelId && state.payrollType) {
        const data = {
          path: calculatePayrollPath,
          data: {
            userId: user.user_id,
            staffId: staffId,
            payrollModelId: state.payrollModelId,
            grossPayAmount: e.target.value,
            grossMonthlyOrYearly: state.grossMonthlyOrYearly,
            payrollType: state.payrollType,
            payrollDate: `${state.month}-01`,
          },
        };
        setErrorMessage("");
        dispatch(commonSaveData(data));
      } else {
        setErrorMessage(
          `Please select ${!state.payrollType ? "Salary Type" : ""} 
         ${!state.payrollModelId && !state.payrollType ? "and" : ""} 
          
          ${!state.payrollModelId ? " Salary Structure" : ""} first to proceed`
        );
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
        // toast.error(
        //   "Please select Salary Type and Salary Structure first to proceed"
        // );
      }
    }
  };

  const handleGrossMonthlyOrYearlyChange = (e) => {
    setState((pre) => ({
      ...pre,
      grossMonthlyOrYearly: e.target.checked ? "1" : "0",
    }));
    setState((pre) => ({
      ...pre,
      data: {},
    }));
    if (state.payrollModelId && state.payrollType) {
      const data = {
        path: calculatePayrollPath,
        data: {
          userId: user.user_id,
          staffId: staffId,
          payrollModelId: state.payrollModelId,
          grossPayAmount: state.grossPayAmount,
          grossMonthlyOrYearly: e.target.checked ? "1" : "0",
          payrollType: state.payrollType,
          payrollDate: `${state.month}-01`,
        },
      };
      setErrorMessage("");
      dispatch(commonSaveData(data));
    } else {
      setErrorMessage(
        `Please select ${!state.payrollType ? "Salary Type" : ""} 
         ${!state.payrollModelId && !state.payrollType ? "and" : ""} 
          ${!state.payrollModelId ? " Salary Structure" : ""} first to proceed`
      );
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
      // toast.error(
      //   "Please select Salary Type and Salary Structure first to proceed"
      // );
    }
  };

  useEffect(() => {
    if (payrollListStore.payrollModListSuccess) {
      setState((pre) => ({
        ...pre,
        payrollList: payrollListStore.payrollModListData || [],
      }));
    }
    if (payrollListStore.payrollModListError) {
    }

    if (commonStore.commonSuccess) {
      setState((pre) => ({
        ...pre,
        data: commonStore.commonData,
        dearnessName: "",
        dearnessMonthlyAmount: "",
        dearnessYearlyAmount: "",
      }));

      setErrorMessage("");
      const earningsArray =
        commonStore.commonData?.salaryOutput?.allowanceList?.filter(
          (item) =>
            item.name != "Other Allowance" && item.name != "Dearness Allowance"
        );
      const dearnessArray =
        commonStore.commonData?.salaryOutput.allowanceList?.filter(
          (item) => item.name == "Dearness Allowance"
        );
      setEarningAllowance(earningsArray || []);

      if (dearnessArray.length > 0) {
        setState((pre) => ({
          ...pre,
          dearnessName: dearnessArray[0].name,
          dearnessMonthlyAmount: dearnessArray[0].monthlyAmount,
          dearnessYearlyAmount: dearnessArray[0].yearlyAmount,
        }));
      }

      const newAllowanceArray = commonStore.commonData?.newAllowanceList?.map(
        (val, idx) => {
          const keys = Object.keys(val)[0];
          const calcArr = val[keys].split("|");
          return {
            id: idx + 1,
            head: keys,
            calculation: calcArr[0],
            calculationType: calcArr[1],
          };
        }
      );
      setNewAllowance(
        commonStore.commonData?.salaryOutput.newAllowanceList || []
      );
      dispatch(initCommonState());
    }
    if (commonStore.commonError) {
      // toast.error(commonStore.commonMessage);
      setErrorMessage(commonStore.commonMessage);
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      setState((pre) => ({
        ...pre,
        data: {},
      }));
      dispatch(initCommonState());
    }
    if (salaryStore.salarySuccess) {
      if (salaryStore.salarySuccess) {
        // toast.success(salaryStore.salaryMessage);
        dispatch(initSalaryState());
        setState((prev) => ({
          ...prev,
          payrollList: [],
          grossPayAmount: "",
          grossMonthlyOrYearly: "0",
          data: {},
        }));

        localStorage.setItem("ctc-added", JSON.stringify(state.data));
        handleSaveSalary();
      }
    }
    if (salaryStore.salaryError) {
      if (salaryStore.salaryError) {
        toast.success(salaryStore.salaryMessage);
        dispatch(initSalaryState());
      }
    }
  }, [dispatch, commonStore, payrollListStore, salaryStore]);

  const [earnings, setEarnings] = useState([
    {
      id: "basic1",
      head: "Basic",
      calculation: "basic",
      amount: 0,
    },

    {
      id: "hra1",
      head: "HRA",
      calculation: "hra",
      amount: 0,
    },

    {
      id: "dearness1",
      head: "Dearness Allowance",
      calculation: "dearness",
      amount: 0,
    },
  ]);
  const addEarningField = (e) => {
    const { value, label } = e;
    setEarnings([
      ...earnings,
      {
        id: value,
        head: label,
        calculation: "",
        amount: 0,
      },
    ]);
  };
  const removeEarningFields = (e, index) => {
    e.preventDefault();
    const rows = [...earnings];
    rows.splice(index, 1);
    setEarnings(rows);
  };
  const handleEarningChanges = (index, e) => {
    const { name, value } = e.target;
    const list = [...earnings];
    list[index][name] = value;
    setEarnings(list);
  };

  const [deductions, setDeductions] = useState([]);
  const addDeductionsField = (e) => {
    const { value, label } = e;
    setDeductions([
      ...deductions,
      {
        id: value,
        head: label,
        calculation: "",
        amount: 0,
      },
    ]);
  };
  const removeDeductionsFields = (e, index) => {
    e.preventDefault();
    const rows = [...deductions];
    rows.splice(index, 1);
    setDeductions(rows);
  };
  const handleDeductionsChanges = (index, e) => {
    const { name, value } = e.target;
    const list = [...deductions];
    list[index][name] = value;
    setDeductions(list);
  };

  const savePayrollEmployee = () => {
    if (Object.keys(state.data).length) {
      const data = {
        path: savePayrollEmployeePath,
        data: {
          userId: user.user_id,
          staffId: staffId,
          payrollModelId: state.payrollModelId,
          grossAmount: state.grossPayAmount,
          grossMonthlyOrYearly: state.grossMonthlyOrYearly,
          payrollType: state.payrollType,
          payrollDate: `${state.month}-01`,
          netSalary: state.data?.salaryOutput?.netSalary,
          ctcAmount: state.data?.salaryOutput.costToCompany,
          // payrollDetails: {
          //   payableDays: state.data?.salaryOutput.payableDays,
          //   presentDays: state.data?.salaryOutput.presentDays,
          //   absentDays: state.data?.salaryOutput.absentDays,
          //   basicPay: state.data?.salaryOutput.basicPay,
          //   hraPay: state.data?.salaryOutput.hraPay,

          //   dearnessAllowanceAmount:
          //     state.data?.salaryOutput.dearnessAllowanceAmount,

          //   otherAllowanceAmount: state.data?.salaryOutput.otherAllowances,
          //   totalAllowanceAmount: state.data?.salaryOutput.totalAllowanceAmount,

          //   grossSalary: state.data?.salaryOutput.grossSalary,
          //   netSalary: state.data?.salaryOutput.netSalary,
          //   takeHomeSalary: state.data?.salaryOutput.takeHomeSalary,
          //   employeePf: state.data?.salaryOutput.employeePf,
          //   employeeESI: state.data?.salaryOutput.employeeEsi,
          //   employerPf: state.data?.salaryOutput.employerPf,
          //   employerESI: state.data?.salaryOutput.employerEsi,
          //   edliCharges: state.data?.salaryOutput.employerEdli,
          //   adminCharges: state.data?.salaryOutput.adminCharges,
          //   totalEmployerContributions:
          //     state.data?.salaryOutput.totalEmployerContributions,
          //   totalEmployeeContributions:
          //     state.data?.salaryOutput.totalEmployeeContributions,
          //   totalProfessionalTax: state.data?.salaryOutput.totalProfessionalTax,
          // },
        },
      };
      dispatch(saveUpdateSalary(data));
    } else {
      toast.error("Please select salary detail first");
    }
  };

  const downloadFile = async (e) => {
    e.preventDefault();
    const table = contentRef.current;
    const doc = new jsPDF();
    doc.text("Salary Details", 14, 10);

    autoTable(doc, {
      html: table,
      startY: 20,
      theme: "grid",
      headStyles: { fillColor: [0, 100, 0] },
      styles: { fontSize: 10 },

      margin: { left: 20, right: 20 },

      didParseCell: function (data) {
        if (typeof data.cell.raw === "string") {
          const centerAlignedRows = [
            "Employee Contributions (B)",
            "Employer Contributions (C)",
          ];

          if (centerAlignedRows.includes(data.cell.raw.trim())) {
            data.cell.styles.halign = "center";
          }
        }
      },
    });

    doc.save(`Salary_Details_of_${staffName}.pdf`);
  };

  const handleChange = (event) => {
    const checked = event.target.checked;
  };

  return (
    <div className="salary-details-container position-relative">
      <div
        className="universal-bg-color"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "60px",
          backgroundColor: "transparent",
        }}
      >
        <h1 className="mt-3 color-white">Gross Amount</h1>
        <div style={{ width: "150px" }}>
          <ButtonCom
            type="button"
            class_name={"p_btn universal-input"}
            text={
              salaryStore.salarySuccess
                ? "Updating Details..."
                : "Update Details"
            }
            url_or_onclick={savePayrollEmployee}
            icon={null}
            width={"150px"}
          />
        </div>
      </div>

      <Form>
        <div
          className="page-body"
          style={{
            paddingLeft: "10px",
            paddingRight: "40px",
            borderBottom: "1px solid lightgray",
          }}
        >
          <Row>
            <Col sm="3">
              <Form.Group>
                <Form.Label className="color-white">
                  Effective Month of Change
                </Form.Label>
                <Form.Control
                  type="month"
                  name="month"
                  max={maxMonth}
                  value={state.month}
                  onChange={handleMonth}
                  className="universal-input"
                />
              </Form.Group>
            </Col>
            <Col sm="2">
              <Form.Group>
                <Form.Label className="color-white">Salary Type</Form.Label>
                <Form.Select
                  name="payrollType"
                  value={state.payrollType}
                  onChange={handleSalaryType}
                  style={{ color: "gray" }}
                  className="universal-input"
                >
                  <option value="">Select Salary Type</option>
                  <option value="monthly" selected>
                    Per Month
                  </option>
                  <option value="weekly">Per Week</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col sm="3">
              <Form.Group>
                <Form.Label className="color-white">
                  Salary Structure
                </Form.Label>
                <Form.Select
                  name="payrollModelId"
                  value={state.payrollModelId}
                  onChange={handleSalaryStructure}
                  style={{ color: "gray" }}
                  className="universal-input"
                >
                  <option value="">Select Salary Structure</option>
                  {state.payrollList?.map((val, idx) => {
                    return (
                      <option value={val.payrollModelId} key={idx}>
                        {val.payrollModelName}
                      </option>
                    );
                  })}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col sm="2">
              <Form.Group>
                <Form.Label className="color-white">Gross Amount</Form.Label>

                <Form.Control
                  type="number"
                  name="grossPayAmount"
                  value={state.grossPayAmount}
                  onChange={handleGrossPayAmount}
                  placeholder="0"
                  className="universal-input"
                />
              </Form.Group>
            </Col>

            <Col sm="2">
              <Form.Group>
                <Form.Label className="color-white">Type</Form.Label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Switch
                    name="grossMonthlyOrYearly"
                    checked={state.grossMonthlyOrYearly == "1"}
                    onChange={handleGrossMonthlyOrYearlyChange}
                    inputProps={{ "aria-label": "controlled" }}
                    label=""
                  />
                  <span style={{ fontSize: "14px", color: "white" }}>
                    Monthly/Yearly
                  </span>
                </div>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col sm="8"></Col>
            <Col sm="4">
              {state.data?.salaryOutput?.netSalary && (
                <Form.Group
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                  }}
                >
                  <div>
                    <Form.Label className="color-white">Net Salary</Form.Label>
                    <Form.Control
                      type="number"
                      value={state.data?.salaryOutput.netSalary}
                      placeholder="0"
                      readOnly
                      className="universal-input"
                    />
                  </div>
                  <div>
                    <Form.Label className="color-white">CTC</Form.Label>
                    <Form.Control
                      type="number"
                      value={state.data?.salaryOutput.costToCompany}
                      placeholder="0"
                      readOnly
                      className="universal-input"
                    />
                  </div>
                </Form.Group>
              )}
            </Col>
          </Row>
        </div>

        <div
          className="page-body"
          // style={{
          //   padding: "30px 10px",
          //   marginTop: "-30px",
          //   height: "calc(100vh - 300px)",
          //   overflow: "scroll",
          // }}
        >
          {state.data?.grossPayAmount ? (
            <div style={{ marginTop: "20px", height: "calc(100vh - 350px)", overflow: "scroll" }}>
              <Row>
                <Col sm="4">
                  <h4 className="mb-2 color-white">Employer Contribution - A</h4>
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th style={{ textAlign: "right" }}>Month</th>
                        <th style={{ textAlign: "right" }}>Annum</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>BASIC</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.basicPay
                          ).toFixed()}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.basicPayYearly
                          ).toFixed(2)}
                        </td>
                      </tr>

                      {state.dearnessName && (
                        <tr>
                          <td>{state.dearnessName}</td>
                          <td style={{ textAlign: "right" }}>
                            {parseFloat(state.dearnessMonthlyAmount).toFixed(2)}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {parseFloat(state.dearnessYearlyAmount).toFixed(2)}
                          </td>
                        </tr>
                      )}

                      <tr>
                        <td>HRA</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(state.data?.salaryOutput.hraPay).toFixed(
                            2
                          )}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.hraPayYearly
                          ).toFixed(2)}
                        </td>
                      </tr>

                      {earningAllowance?.map((val, idx) => {
                        return (
                          <tr key={idx}>
                            <td>{val.name}</td>
                            <td style={{ textAlign: "right" }}>
                              {parseFloat(val.monthlyAmount).toFixed(2)}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {parseFloat(val.yearlyAmount).toFixed(2)}
                            </td>
                          </tr>
                        );
                      })}

                      <tr>
                        <td>Other Allowance</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.otherAllowances
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.otherAllowancesYearly
                          ).toFixed(2)}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <strong>Gross Salary (A)</strong>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.grossSalary
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.grossSalaryYearly
                          ).toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>

                <Col sm="4">
                  <h4 className="mb-2 color-white">Employee Contribution - B</h4>
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th style={{ textAlign: "right" }}>Month</th>
                        <th style={{ textAlign: "right" }}>Annum</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {state.data?.salaryOutput.employeePFText} {}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.employeePf
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.employeePfYearly
                          ).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td>ESI (0.75% on Gross)</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.employeeEsi
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.employeeEsiYearly
                          ).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td>Professional Tax</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.professionalTax
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.professionalTaxYearly
                          ).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td>LWF</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.lwfAmount
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>{"0.00"}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Total Deduction </strong>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {(
                            parseFloat(state.data?.salaryOutput.employeePf) +
                            parseFloat(state.data?.salaryOutput.employeeEsi) +
                            parseFloat(state.data?.salaryOutput.lwfAmount) +
                            parseFloat(state.data?.salaryOutput.professionalTax)
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {(
                            parseFloat(
                              state.data?.salaryOutput.employeePfYearly
                            ) +
                            parseFloat(
                              state.data?.salaryOutput.employeeEsiYearly
                            ) +
                            parseFloat(
                              state.data?.salaryOutput.lwfAmountYearly
                            ) +
                            parseFloat(
                              state.data?.salaryOutput.professionalTaxYearly
                            )
                          ).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Net Salary</strong>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.netSalary
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.netSalaryYearly
                          ).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Total Employee Contribution</strong>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.totalEmployeeContributions
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput
                              .totalEmployeeContributionsYearly
                          ).toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>

                <Col sm="4">
                  <h4 className="mb-2 color-white">Employee Contribution - C</h4>
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th style={{ textAlign: "right" }}>Month</th>
                        <th style={{ textAlign: "right" }}>Annum</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          PF (
                          {state.data?.salaryOutput.employerEdli > 0 ||
                          state.data?.salaryOutput.adminCharges > 0
                            ? "13%"
                            : "12%"}
                          on Basic
                          {state.data?.salaryOutput.employerEdli > 0 &&
                            " + EDLI"}
                          {state.data?.salaryOutput.adminCharges > 0 &&
                            " + Admin Charges"}
                          )
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {(
                            parseFloat(state.data?.salaryOutput.employerPf) +
                            parseFloat(state.data?.salaryOutput.employerEdli) +
                            parseFloat(state.data?.salaryOutput.adminCharges)
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {(
                            parseFloat(
                              state.data?.salaryOutput.employerPfYearly
                            ) +
                            parseFloat(
                              state.data?.salaryOutput.employerEdliYearly
                            ) +
                            parseFloat(
                              state.data?.salaryOutput.adminChargesYearly
                            )
                          ).toFixed(2)}
                        </td>
                      </tr>

                      <tr>
                        <td>ESI (3.25% on Gross)</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.employerEsi
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.employerEsiYearly
                          ).toFixed(2)}
                        </td>
                      </tr>

                      <tr>
                        <td>LWF</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.employerLwfAmount
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.employerLwfAmountYearly
                          ).toFixed(2)}
                        </td>
                      </tr>

                      {newAllowance?.map((val, idx) => {
                        return (
                          <tr key={idx}>
                            <td>{val.name}</td>
                            <td style={{ textAlign: "right" }}>
                              {parseFloat(val.monthlyAmount).toFixed(2)}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {parseFloat(val.yearlyAmount).toFixed(2)}
                            </td>
                          </tr>
                        );
                      })}

                      <tr>
                        <td>
                          <strong>Total Employer Contribution</strong>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.totalEmployerContributions
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput
                              .totalEmployerContributionsYearly
                          ).toFixed(2)}
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <strong> Total CTC A+C</strong>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <strong>
                            {(
                              parseFloat(state.data?.salaryOutput.grossSalary) +
                              parseFloat(
                                state.data?.salaryOutput
                                  .totalEmployerContributions
                              )
                            ).toFixed(2)}
                          </strong>
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <strong>
                            {(
                              parseFloat(
                                state.data?.salaryOutput.grossSalaryYearly
                              ) +
                              parseFloat(
                                state.data?.salaryOutput
                                  .totalEmployerContributionsYearly
                              )
                            ).toFixed(2)}
                          </strong>
                        </td>
                      </tr>

                      <tr>
                        <td>Total CTC</td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.costToCompany
                          ).toFixed(2)}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {parseFloat(
                            state.data?.salaryOutput.costToCompanyYearly
                          ).toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            </div>
          ) : (
            // <div>
            //   <div
            //     style={{
            //       display: "flex",
            //       alignItems: "center",
            //       justifyContent: "flex-end",
            //       marginBottom: "10px",
            //     }}
            //   >
            //     <ButtonCom
            //       type="button"
            //       class_name={"p_btn"}
            //       text="Download"
            //       url_or_onclick={downloadFile}
            //       icon={null}
            //       width={""}
            //     />
            //   </div>
            //   <div style={{ height: "40dvh", overflow: "scroll" }}>
            //     <table className="table table-bordered " ref={contentRef}>
            //       <thead>
            //         <tr>
            //           <td></td>
            //           <td style={{ textAlign: "center" }}>Per Month</td>
            //           <td style={{ textAlign: "center" }}>Per Annum</td>
            //         </tr>
            //       </thead>

            //       <tbody>
            //         <tr>
            //           <td>BASIC</td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.basicPay}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.basicPayYearly}
            //           </td>
            //         </tr>

            //         {state.dearnessName && (
            //           <tr>
            //             <td>{state.dearnessName}</td>
            //             <td style={{ textAlign: "right" }}>
            //               {state.dearnessMonthlyAmount}
            //             </td>
            //             <td style={{ textAlign: "right" }}>
            //               {state.dearnessYearlyAmount}
            //             </td>
            //           </tr>
            //         )}

            //         <tr>
            //           <td>HRA</td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.hraPay}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.hraPayYearly}
            //           </td>
            //         </tr>

            //         {earningAllowance?.map((val, idx) => {
            //           return (
            //             <tr key={idx}>
            //               <td>{val.name}</td>
            //               <td style={{ textAlign: "right" }}>
            //                 {val.monthlyAmount}
            //               </td>
            //               <td style={{ textAlign: "right" }}>
            //                 {val.yearlyAmount}
            //               </td>
            //             </tr>
            //           );
            //         })}

            //         <tr>
            //           <td>Other Allowance</td>
            //           <td style={{ textAlign: "right" }}>
            //             {
            //               // parseFloat(
            //               //   state.data?.salaryOutput.otherAllowanceSystemCalc
            //               // ) +
            //               parseFloat(state.data?.salaryOutput.otherAllowances)
            //             }
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {
            //               // parseFloat(
            //               //   state.data?.salaryOutput.otherAllowanceSystemCalc
            //               // ) *
            //               //   12 +
            //               parseFloat(
            //                 state.data?.salaryOutput.otherAllowancesYearly
            //               )
            //             }
            //           </td>
            //         </tr>

            //         <tr>
            //           <td>
            //             <strong>Gross Salary (A)</strong>
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.grossSalary}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.grossSalaryYearly}
            //           </td>
            //         </tr>

            //         <tr>
            //           <td colSpan={3} style={{ textAlign: "center" }}>
            //             <strong> Employee Contributions (B)</strong>
            //           </td>
            //         </tr>

            //         <tr>
            //           {/* <td>PF (12% on Basic)</td> */}
            //           <td>
            //             {state.data?.salaryOutput.employeePFText} {}{" "}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.employeePf}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.employeePfYearly}
            //           </td>
            //         </tr>

            //         <tr>
            //           <td>ESIC (0.75% on Gross)</td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.employeeEsi}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.employeeEsiYearly}
            //           </td>
            //         </tr>

            //         <tr>
            //           <td>Professional Tax</td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.professionalTax}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.professionalTaxYearly}
            //           </td>
            //         </tr>

            //         <tr>
            //           <td>LWF</td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.lwfAmount}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.lwfAmountYearly}
            //           </td>
            //         </tr>

            //         <tr>
            //           <td>
            //             <strong>Total Deduction </strong>
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {parseFloat(state.data?.salaryOutput.employeePf) +
            //               parseFloat(state.data?.salaryOutput.employeeEsi) +
            //               parseFloat(state.data?.salaryOutput.lwfAmount) +
            //               parseFloat(state.data?.salaryOutput.professionalTax)}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {parseFloat(state.data?.salaryOutput.employeePfYearly) +
            //               parseFloat(
            //                 state.data?.salaryOutput.employeeEsiYearly
            //               ) +
            //               parseFloat(state.data?.salaryOutput.lwfAmountYearly) +
            //               parseFloat(
            //                 state.data?.salaryOutput.professionalTaxYearly
            //               )}
            //           </td>
            //         </tr>

            //         <tr>
            //           <td>
            //             <strong>Net Salary</strong>
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.netSalary}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.netSalaryYearly}
            //           </td>
            //         </tr>

            //         <tr>
            //           <td>
            //             <strong>Total Employee Contribution</strong>
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.totalEmployeeContributions}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {
            //               state.data?.salaryOutput
            //                 .totalEmployeeContributionsYearly
            //             }
            //           </td>
            //         </tr>

            //         <tr>
            //           <td colSpan={3} style={{ textAlign: "center" }}>
            //             <strong> Employer Contributions (C)</strong>
            //           </td>
            //         </tr>

            //         <tr>
            //           <td>
            //             PF ({" "}
            //             {state.data?.salaryOutput.employerEdli > 0 ||
            //             state.data?.salaryOutput.adminCharges > 0
            //               ? "13%"
            //               : "12%"}{" "}
            //             on Basic
            //             {state.data?.salaryOutput.employerEdli > 0 &&
            //               " + EDLI"}{" "}
            //             {state.data?.salaryOutput.adminCharges > 0 &&
            //               " + Admin Charges"}
            //             )
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {parseFloat(state.data?.salaryOutput.employerPf) +
            //               parseFloat(state.data?.salaryOutput.employerEdli) +
            //               parseFloat(state.data?.salaryOutput.adminCharges)}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {parseFloat(state.data?.salaryOutput.employerPfYearly) +
            //               parseFloat(
            //                 state.data?.salaryOutput.employerEdliYearly
            //               ) +
            //               parseFloat(
            //                 state.data?.salaryOutput.adminChargesYearly
            //               )}
            //             {/* {state.data?.salaryOutput.employerPfYearly} */}
            //           </td>
            //         </tr>

            //         <tr>
            //           <td>ESIC (3.25% on Gross)</td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.employerEsi}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.employerEsiYearly}
            //           </td>
            //         </tr>

            //         <tr>
            //           <td>LWF</td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.employerLwfAmount}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.employerLwfAmountYearly}
            //           </td>
            //         </tr>

            //         <tr>
            //           <td>
            //             <strong>Total Employer Contribution</strong>
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.totalEmployerContributions}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {
            //               state.data?.salaryOutput
            //                 .totalEmployerContributionsYearly
            //             }
            //           </td>
            //         </tr>

            //         <tr>
            //           <td>
            //             <strong> Total CTC A+C</strong>
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             <strong>
            //               {parseFloat(state.data?.salaryOutput.grossSalary) +
            //                 parseFloat(
            //                   state.data?.salaryOutput
            //                     .totalEmployerContributions
            //                 )}
            //             </strong>
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             <strong>
            //               {parseFloat(
            //                 state.data?.salaryOutput.grossSalaryYearly
            //               ) +
            //                 parseFloat(
            //                   state.data?.salaryOutput
            //                     .totalEmployerContributionsYearly
            //                 )}
            //             </strong>
            //           </td>
            //         </tr>

            //         {/* <tr>
            //     <td>Management Fee 5%</td>
            //     <td style={{ textAlign: "right" }}>1950</td>
            //     <td style={{ textAlign: "right" }}>23400</td>
            //   </tr> */}

            //         {newAllowance?.map((val, idx) => {
            //           return (
            //             <tr key={idx}>
            //               <td>{val.name}</td>
            //               <td style={{ textAlign: "right" }}>
            //                 {val.monthlyAmount}
            //               </td>
            //               <td style={{ textAlign: "right" }}>
            //                 {val.yearlyAmount}
            //               </td>
            //             </tr>
            //           );
            //         })}

            //         <tr>
            //           <td>Total CTC</td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.costToCompany}
            //           </td>
            //           <td style={{ textAlign: "right" }}>
            //             {state.data?.salaryOutput.costToCompanyYearly}
            //           </td>
            //         </tr>
            //       </tbody>
            //     </table>
            //   </div>
            // </div>
            <center>
              <h3
                style={{
                  position: "absolute",
                  left: "50%",
                  top: "200%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                No Records
              </h3>

              <p style={{ color: "red", marginTop: "20px" }}>{errorMessage}</p>
            </center>
          )}
        </div>
      </Form>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default SalaryDetails;
